export const INDIVIDUAL_CODE_TYPE = 1
export const EDUCATIVE_CENTER_CODE_TYPE = 2
export const CENTER_CODE_TYPE = 3
export const HOTELS_CODE_TYPE = 4
export const TRAVEL_CODE_TYPE = 5
export const GENERIC_CODE_TYPE = 6

export default {
	INDIVIDUAL_CODE_TYPE,
	EDUCATIVE_CENTER_CODE_TYPE,
	CENTER_CODE_TYPE,
	HOTELS_CODE_TYPE,
	TRAVEL_CODE_TYPE,
	GENERIC_CODE_TYPE
}


// WEBPACK FOOTER //
// ./src/constants/db/companyCodeTypes.js